module.exports = __webpack_public_path__ + "img/40_38_055_710.92fe9382.jpg";